import { useState, useEffect } from 'react';

export default function Hero() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
        <img
          src="https://public.readdy.ai/ai/img_res/30504721aeda7ddf3b98e5cf152d3ccc.jpg"
          alt="Digital Network"
          className="w-full h-full object-cover object-top opacity-40"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
        <div
          className={`transition-all duration-1000 ease-out ${
            mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h1 className="text-5xl md:text-7xl font-extralight text-white mb-6 leading-tight tracking-tight">
            A essência do seu negócio,<br />
            <span className="font-light text-purple-400">arquitetada por quem entende</span><br />
            de conexões
          </h1>
        </div>

        <div
          className={`transition-all duration-1000 ease-out delay-300 ${
            mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
          style={{ transitionDelay: '300ms' }}
        >
          <p className="text-lg md:text-xl text-gray-300 font-light mb-12 max-w-3xl mx-auto leading-relaxed">
            Traduzimos a alma da sua marca para o mundo digital com soluções estratégicas, humanas e sob medida.
          </p>
        </div>

        <div
          className={`transition-all duration-1000 ease-out ${
            mounted ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-6 scale-95'
          }`}
          style={{ transitionDelay: '600ms' }}
        >
          <button
            onClick={scrollToContact}
            className="inline-block px-10 py-4 bg-purple-600 text-white text-base font-light tracking-wide rounded-full hover:bg-purple-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg shadow-purple-600/30"
          >
            Quero uma Consultoria Exclusiva
          </button>
        </div>
      </div>

      <div
        className={`absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce transition-opacity duration-1000 ${
          mounted ? 'opacity-60' : 'opacity-0'
        }`}
        style={{ transitionDelay: '1000ms' }}
      >
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </section>
  );
}
